import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useTranslation } from "react-i18next";
import Modal from "../../../components/Modal/Modal";
import CreateCustomWidget from "../../../views/Dashboard/CreateCustomWidget";
import { filesPreloading } from "../../../services/fileUploadService";

const useStyles = makeStyles(theme => ({
  tabs: {
    marginBottom: theme.spacing(3)
  },
  saveButton: {
    marginLeft: 24
  }
}));

const EditCustomWidgetModal = ({
  open,
  onClose,
  onUpdateCustomWidget,
  widgetData,
  btnDisabled,
  ownPrivateWidget,
  setWidgetContent
}) => {
  const [customWidgetData, setCustomWidgetData] = useState(widgetData);
  const [customWidgetFormHasError, setCustomWidgetFormHasError] = useState(
    false
  );
  const [filesList, setFilesList] = React.useState([]);

  const { t } = useTranslation();

  const classes = useStyles();

  const handleCustomWidgetDataChange = customWidgetData => {
    setCustomWidgetData(customWidgetData);
  };

  const handleCancelClick = () => {
    onClose();
  };

  const handleSaveCustomWidget = async () => {
    if (
      Object.keys(customWidgetData).some(widget =>
        !!customWidgetData[widget] ? customWidgetData[widget].error : false
      )
    ) {
      setCustomWidgetFormHasError(true);
    } else {
      const tmpObj = await filesPreloading(
        filesList,
        customWidgetData.content.value
      );
      const updateWidgetData = {
        id: customWidgetData.id.value,
        name: customWidgetData.name.value,
        description: customWidgetData.description.value,
        isPrivate: customWidgetData.isPrivate.value,
        creatorId: customWidgetData.creatorId,
        content: tmpObj.content,
        images: tmpObj.images,
        media: tmpObj.media,
        attachments: tmpObj.attachments
      };

      onUpdateCustomWidget(updateWidgetData);
      setWidgetContent(updateWidgetData);
      onClose();
    }
  };

  function getDialogContent() {
    return (
      <CreateCustomWidget
        onChange={handleCustomWidgetDataChange}
        formSaveAttempted={customWidgetFormHasError}
        widgetData={widgetData}
        ownPrivateWidget={ownPrivateWidget}
        onFileAdd={(fileObj, tempLink, type) => {
          let list = filesList;
          list.push({ fileObj, tempLink, type });
          setFilesList(list);
        }}
      />
    );
  }

  function getDialogActions() {
    return (
      <>
        <Button
          onClick={handleCancelClick}
          color="primary"
          disabled={btnDisabled}
        >
          {t("cancelBtn")}
        </Button>
        <Button
          onClick={handleSaveCustomWidget}
          className={classes.saveButton}
          color="primary"
          variant="contained"
        >
          {t("saveBtn")}
        </Button>
      </>
    );
  }
  return (
    <Modal
      disableEnforceFocus
      showCloseIcon
      dialogTitle={
        <Typography variant="h4" color="textPrimary">
          {t("customWidget.editModal.title")}
        </Typography>
      }
      open={open}
      onClose={onClose}
      dialogContent={getDialogContent()}
      dialogActions={getDialogActions()}
      maxWidth="sm"
      fullWidth
      scrollable
      padding="none"
    />
  );
};

EditCustomWidgetModal.propTypes = {
  /**
   * Data that will be displayed in the widget / edit form
   */
  widgetData: PropTypes.object,
  /**
   * True if the modal is open, false otherwise
   */
  open: PropTypes.bool.isRequired,
  /**
   * Called when the modal is closed
   */
  onClose: PropTypes.func,
  /**
   * Called when a custom widget is saved
   */
  onUpdateCustomWidget: PropTypes.func
};

export default EditCustomWidgetModal;
